import type { IconData } from '@stacksjs/iconify-core'

export const anchor: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 22a8.01 8.01 0 0 1-8-8a1 1 0 0 1 2 0a6 6 0 0 0 12 0a1 1 0 0 1 2 0a8.01 8.01 0 0 1-8 8\"/><path fill=\"currentColor\" d=\"M12 22a1 1 0 0 1-1-1V7a1 1 0 0 1 2 0v14a1 1 0 0 1-1 1m-5-7H5a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m12 0h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2\"/><path fill=\"currentColor\" d=\"M14 11h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2m-2-3a3 3 0 1 1 3-3a3.003 3.003 0 0 1-3 3m0-4a1 1 0 1 0 1 1a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default anchor
